import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Paper } from '@mui/material';
import DataCall from './DataCall';
import MobileCall from './MobileCall';
import VICIDial from './VICIDial';

interface CallLoadingProps {
    call: any;
    user: any;
}

const CallLoading: React.FC<CallLoadingProps> = ({ call, user }) => {
    const [isWindowOpen, setIsWindowOpen] = useState<boolean>(true);

    const windowToggle = (flag: boolean) => {
        setIsWindowOpen(flag);
    };

    return (
        <>
            <Modal
                open={isWindowOpen && !!call}
                onClose={() => windowToggle(false)}
                aria-labelledby="call-modal"
                aria-describedby="call-interface"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Paper
                    elevation={24}
                    sx={{
                        width: call?.type === 'vici' ? '100%' : '90%',
                        maxWidth: call?.type === 'vici' ? '100%' : 500,
                        height: call?.type === 'vici' ? '100%' : '70%',
                        maxHeight: call?.type === 'vici' ? '100%' : 600,
                        outline: 'none',
                        borderRadius: call?.type === 'vici' ? 0 : 2,
                        overflow: 'hidden',
                    }}
                >
                    {call && call.type === 'mobile' ? (
                        <MobileCall windowToggle={windowToggle} />
                    ) : call && call.type === 'vici' ? (
                        <VICIDial call={call} user={user} />
                    ) : (
                        <DataCall windowToggle={windowToggle} />
                    )}
                </Paper>
            </Modal>

            {/* Alternative: Fixed position overlay (similar to React Native) */}
            {/* Uncomment this if you prefer the overlay approach */}
            {/* 
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: isWindowOpen ? '400px' : 0,
          backgroundColor: '#CCCCCC',
          zIndex: 9999,
          transition: 'height 0.3s ease-in-out',
          overflow: 'hidden',
        }}
      >
        {call && call.type === 'mobile' ? (
          <MobileCall windowToggle={windowToggle} />
        ) : (
          <DataCall windowToggle={windowToggle} />
        )}
      </Box>
      */}
        </>
    );
};

const mapStateToProps = (state: any) => ({
    user: state.user.user,
});

export default connect(mapStateToProps, null)(CallLoading);